<template>
  <div id="trunk">
    <lead />
    <main class="main i_maxW">
      <router-view />
    </main>
    <foote />
  </div>
</template>

<script>
import lead from "./head";
import foote from '@/components/common/footer';
export default {
  components: {
    lead, foote,
  },
}
</script>
<style lang="scss">
.main {
  box-sizing: border-box;
  min-height: calc(100vh - 124px);
  padding: 25px 0 40px;
}
@import "./../../../assets/css/netteach.scss";
</style>